/*jshint esversion: 6 */

import Ajax from "./Ajax";

let CountrySelector = (function(){

    let selector = '.dialog.modal.location.selector';

    let setupCountrySelectorInterface = function (dialogSelector) {
        selector = dialogSelector || selector;
        // jquery ui dialog
        $(selector).dialog({
            autoOpen: false,
            draggable: false,
            resizable: false,
            width: window.innerWidth-10,
            modal: true,
            dialogClass: "country selector",
            position: {
                my: "center top",
                at: "center top",
                of: "body"
            },
            title: "VPN simulation",
            show: {
                effect: "blind",
                duration: 500
            },
            hide: {
                effect: "blind",
                duration: 500
            },
            closeOnEscape: true,
        });
        const selectCountryButton = document.querySelector('.select.country')
        if (selectCountryButton) {
            selectCountryButton.addEventListener('click', function() {
                $(selector).dialog("open");
            });
        }
        document.querySelectorAll(selector + ' .country.button').forEach(function(button) {
            button.addEventListener('click', function() {

                let currentIsocode = document.querySelector(selector + ' td.current.isocode').textContent;
                let nextIsocode = this.textContent;
                let nextIp = this.getAttribute('data-ip');
                let nextCountry = this.getAttribute('title');

                // Modify the interface given the selection

                document.querySelectorAll(selector + ' .country.button').forEach(function(btn) {
                    btn.classList.remove('active');
                });
                this.classList.add('active');

                const nextLocationElement = document.querySelector(selector + ' .next.location');
                if (nextLocationElement) {
                    nextLocationElement.textContent = nextIsocode;
                }

                const browseButton = document.querySelector(selector + ' button.browse');
                if (browseButton) {
                    browseButton.classList.remove('hidden'); // .removeClass('hidden')
                    browseButton.setAttribute('data-ip', nextIp); // .attr('data-ip', nextIp)

                    if (nextIsocode === currentIsocode) {
                        browseButton.classList.remove('active');
                    } else {
                        browseButton.classList.add('active');
                    }
                }

                const browseButtonSpan = document.querySelector(selector + ' button.browse span');
                if (browseButtonSpan) {
                    browseButtonSpan.textContent = ` (${nextIsocode})`;
                }

                const nextIsocodeElement = document.querySelector(selector + ' .next.isocode');
                if (nextIsocodeElement) {
                    nextIsocodeElement.textContent = nextIsocode;
                }
                const nextIpAddressElement = document.querySelector(selector + ' .next.ipaddress');
                if (nextIpAddressElement) {
                    nextIpAddressElement.textContent = nextIp;
                }
                const nextCountryElement = document.querySelector(selector + ' .next.country');
                if (nextCountryElement) {
                    nextCountryElement.textContent = nextCountry;
                }
            });
        });

        // Button which confirms selection and refreshes page
        const browseButton = document.querySelector(selector + ' button.browse');
        if (browseButton) {
            browseButton.addEventListener('click', function() {
                const fromIp = this.getAttribute('data-ip');

                if (fromIp) {
                    setIpAddress(fromIp);
                } else {
                    alert('Unknown location');
                }
            });
        }

    };

    // Makes an ajax call to set the ipaddress in the session
    const setIpAddressSuccess = function(){
        const flashMessageElement = document.querySelector(selector + ' .flash-message');
        if (flashMessageElement) {
            flashMessageElement.textContent = 'The page will now reload';
            flashMessageElement.classList.remove('hidden');
        }
        location.reload();
    };
    const setIpAddressError = function(response){
        alert('There was an error: ' + response);
    };
    const setIpAddress = function(ipAddress){
        let route = window.location.protocol + '//' + window.location.hostname;
        if (ENV === 'dev') {
            //route = route + '/app_dev.php';
        }
        route = `${route}/en/widget/country/ip/${ipAddress}`;
        Ajax.getRequest(route, setIpAddressSuccess, setIpAddressError);
    };


    return {
        setupCountrySelectorInterface: setupCountrySelectorInterface,
    };

})();

export default CountrySelector;